import { BackCard } from './BackCard';

export default BackCard;
